import React from 'react'
import { useState, useEffect } from 'react'
import Searchbar from '../../../components/forms/searchbar'
import Item from './item'
import ApiUrl from '../../../configTools/apiUrl'
import Searchbar2 from '../../../components/forms/searchbar2'


const User = () => {
  const UserInfo = JSON.parse(localStorage.getItem("user-info"));
  const [UserList,setUser] = useState([]);
  const [Filter,setFilter] = useState(UserList);
  useEffect(() => {
    fetch(ApiUrl.API_URL_User, {
      method: 'GET',
      headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer '+UserInfo.token
      }
    })
    .then(res=>res.json())
    .then(data =>{
      setUser(data);
    });
  },[])
  return (
    <div className='admin_forms_main_container'>
      <div className='form_table_container'>
        <Searchbar2 Values={UserList} setFilter={setFilter}/>
        <div>
          <div>
              <div className='form_item_row_container title'>
              <div className='form_item_row_container_item' style={{width:'10%'}}>
                  <p></p>
              </div>
              <div className='form_item_row_container_item' style={{width:'20%'}}>
                  <p>Firstname</p>
              </div>
              <div className='form_item_row_container_item' style={{width:'20%'}}>
                  <p>Lastname</p>
              </div>
              <div className='form_item_row_container_item' style={{width:'30%'}}>
                  <p>Username</p>
              </div>
              <div className='form_item_row_container_item' style={{width:'20%'}}>
                  <p>Role</p>
              </div>
              </div>
          </div>
          <div>
          {
            Filter.map((item,index)=>{
              return(
                item.role !== "admin" &&
                  <div key={index}>
                    <Item Obj = {item} key={item.id} />
                  </div>
              );
            })
          }
          </div>
        </div>
      </div>
    </div>
  )
}

export default User
